import { Box, FlexBox } from '@dixa/lib-shared-habla';

import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';
import { sanitizeHtml } from 'utils/sanitizeHtml';

type RoutedThroughMessengerMenuProps = {
  node: ConversationFlowAuditLogEntry<'MESSENGER_MENU_NODE_VISITED'>;
};

export function RoutedThroughMessengerMenu({
  node,
}: RoutedThroughMessengerMenuProps): JSX.Element {
  const sanitizedQuestion = node.question && (
    <Box
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(node.question, 'plainText'),
      }}
    />
  );
  return (
    <FlexBox>
      Menu ·{' '}
      {node.label ? (
        <>
          Selected&nbsp;
          <strong>{node.label}</strong>
        </>
      ) : (
        <>
          Question&nbsp;<strong>{sanitizedQuestion}</strong>;
        </>
      )}
    </FlexBox>
  );
}
